import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import ProductCarousel from '../../components/ProductCarousel/ProductCarousel';
import {
  ArrivalWrapper,
  ArrivalTitle,
	ViewAll,
} from '../Products/Products.style';
import t from '../../i18n/translate';

/**
 * NewProducts Component
 * Displays new arrival products using the reusable ProductCarousel
 */
const NewProducts = ({deviceType, props}) => {

	// Memoize products to render
	const productsToRender = useMemo(() => {
		if (props.FilteredNameProducts === false && props.arrivalproducts) {
			return props.arrivalproducts;
    }
		return [];
	}, [props.FilteredNameProducts, props.arrivalproducts]);

	// Header component with title and "View All" link
	const HeaderComponent = (
		<ArrivalWrapper className={props.cartType}>
			<ArrivalTitle>{t('home_new_arrivals_label')}</ArrivalTitle>
			<ViewAll>
				<a
					href="/best-deals/new-arrivals"
					target="_blank"
					rel="noopener noreferrer"
					style={{textDecoration: 'none', color: 'inherit'}}
				>
					{t('home_view_all_label')}
				</a>
			</ViewAll>
		</ArrivalWrapper>
	);

	return (
		<ProductCarousel
			products={productsToRender}
			loading={props.arrivalloading}
			deviceType={deviceType}
			cartType={props.cartType}
			HeaderComponent={HeaderComponent}
		/>
  );
};

NewProducts.propTypes = {
	deviceType: PropTypes.string,
	props: PropTypes.shape({
		arrivalproducts: PropTypes.array,
		arrivalloading: PropTypes.bool,
		FilteredNameProducts: PropTypes.bool,
		cartType: PropTypes.string,
	}).isRequired,
};

NewProducts.defaultProps = {
	deviceType: 'desktop',
};

export default React.memo(NewProducts);
